<template>
  <div>
    <AuditFileListImport ref="import" v-on:uploaded="fileUpload" />
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        {{ $t("auditoria") }}
        <el-form style="float: right; padding: 3px 0" :inline="true">
          <el-button type="success" plain @click="$router.push({ name: 'services.audit' })">Ver
            pendências</el-button>&nbsp;
          <AuditFileListFilter ref="filter" v-on:filter="fetchRecords" />&nbsp;
          <el-button type="primary" @click="$refs.import.open()">Importar planilha</el-button>
        </el-form>
      </div>
      <AuditFileDetail :list="tableData" />
    </el-card>
  </div>
</template>

<script>
import { AuditService } from "@/services/customers/audit.services";
import { UserService } from "@/services/users/user.services";
import AuditFileDetail from './AuditFileDetail';
import AuditFileListFilter from './AuditFileListFilter.vue';
import AuditFileListImport from './AuditFileListImport.vue';

export default {
  name: "AuditFileList",
  components: {
    AuditFileDetail,
    AuditFileListImport,
    AuditFileListFilter
  },
  data() {
    return {
      tableData: [],
      user: {
        type: "1",
      },
    };
  },
  methods: {
    fileUpload(id, event = true) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      AuditService.findfile(id)
        .then((response) => {
          const index = vm.tableData.findIndex(x => x.id === id);
          if (index === -1) {
            vm.tableData.unshift(response)
          } else {
            vm.tableData.splice(index, 1);
            vm.tableData.unshift(response);
          }
          if (event) {
            vm.$bus.$emit("audit", id);
          }
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    fetchRecords() {
      const vm = this;
      vm.tableData = [];
      const loading = vm.$loading(vm.$options.loading);
      const filter = vm.$refs.filter.get();
      AuditService.files(filter)
        .then((response) => {
          vm.tableData = response;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
  },
  mounted() {
    const vm = this;
    vm.$bus.$on("audit.file.processed", (id) => {
      vm.fileUpload(id, false);
    });
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
        vm.user = response;
        vm.fetchRecords();
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>
<style scoped>
.el-upload--text {
  width: 100%;
}

.el-upload--text {
  width: 100%;
}
</style>